export enum ReplicationsListFilter {
  All = 'all',
  Aws = 'aws',
  Gcp = 'gcp',
}

export enum ReplicationPlatform {
  Aws = 'aws',
  Gcp = 'gcp',
}

export enum ReplicationWatcherType {
  Copy = 'copy',
  Delete = 'delete',
  Update = 'update',
}

export enum ReplicationWatcherOnHandlerType {
  FileUploaded = 'file-uploaded',
  FileDeleted = 'file-deleted',
  FileUpdated = 'file-updated',
}

export interface ReplicationReplica {
  bucket: string;
  credentialId: string;
  platform: string;
}

export interface ReplicationWatcherAction<T = ReplicationWatcherType> {
  bucket: string;
  credentialId: string;
  platform: string;
  type: T;
}

interface ReplicationWatcherOnHandler<T = ReplicationWatcherOnHandlerType> {
  bodyFilters: ReplicationBodyFilters[];
  type: T;
}

export interface ReplicationWatcher<
  T = ReplicationWatcherType,
  H = ReplicationWatcherOnHandlerType,
> {
  actions: ReplicationWatcherAction<T>[];
  id: string;
  on: ReplicationWatcherOnHandler<H>;
}

export interface Replication {
  id: string;
  enabled: boolean;
  name: string;
  platform: ReplicationPlatform;
  dateCreated: string; // "2017-01-23T14:08:33.020Z"
  dateUpdated: string; // "2017-01-23T14:08:33.020Z"
  replica: ReplicationReplica;
  copy: ReplicationWatcher<ReplicationWatcherType.Copy>;
  delete: ReplicationWatcher<ReplicationWatcherType.Delete>;
  update: ReplicationWatcher<ReplicationWatcherType.Update>;
}

export interface ReplicationPayload {
  id: string;
  enabled: boolean;
  name: string;
  dateCreated: string; // "2017-01-23T14:08:33.020Z"
  dateUpdated: string; // "2017-01-23T14:08:33.020Z"
  replica: ReplicationReplica;
  copy: ReplicationPayloadWatcher<ReplicationWatcherType.Copy>;
  delete: ReplicationPayloadWatcher<ReplicationWatcherType.Delete>;
  update: ReplicationPayloadWatcher<ReplicationWatcherType.Update>;
}

export interface ReplicationPayloadWatcher<
  T = ReplicationWatcherType,
  H = ReplicationWatcherOnHandlerType,
> {
  actions: ReplicationWatcherAction<T>[];
  id: string;
  on: ReplicationPayloadWatcherOnHandler<H>;
}

interface ReplicationPayloadWatcherOnHandler<
  T = ReplicationWatcherOnHandlerType,
> {
  bodyFilters: ReplicationPayloadBodyFilters[];
  type: T;
}

export interface ReplicationCredentialsResponse {
  encryptedKey: string; // "CiQAPpyvIbZcc/cMsnMqMevpQMlWF1K+w5MBX2lTn7wfwTSJljUSigEAMtJE48MiU3lXFcmlE0n3mKT5qwrES1tHFUrgjAlcfWX9nInTZzCM8qei/IF1kwWeqJ254LfLa3LQSuiKu1gq51FHGjdEBBD8b5/0mCHOGn7r9LyWtJ/NSbWD/8P7GnoyrKhiMLmjETltHW+1l/l2f/Phq1ce9GrYfr94mXzHceiFa+fssuzaBS0="
  id: string; // "6f3e253be8574c3eaaf675274a59d09b"
  platform: string; // "urn:platform:aws"
  type: string; // "service-account"
}

interface ReplicationPayloadBodyFilter {
  [name: string]: string;
}

export type ReplicationPayloadBodyFilters = ReplicationPayloadBodyFilter[];

export interface ReplicationBodyFilters {
  size?: string;
  path?: string;
  mimeType?: string;
  access?: string;
}

export type ReplicationBodyFiltersPayload = {
  [key: string]: string | undefined;
}[][];
